import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@cadmakers-ui/icons";
import Menu from "./Menu";

export const DotsMenu = ({
  children,
  clickPropagationStopped
}: {
  children: any;
  clickPropagationStopped: boolean;
}) => {
  return (
    <Menu
      elementToClick={<Icon appName="GeneralLayout" assetName="GENERAL_L_Menu3Dots" />}
      clickPropagationStopped={clickPropagationStopped}
    >
      {children}
    </Menu>
  );
};

DotsMenu.propTypes = {
  children: PropTypes.node.isRequired,
  clickPropagationStopped: PropTypes.bool
};

DotsMenu.defaultProps = {
  clickPropagationStopped: false
};
